import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { setProps } from 'redux/actions'
import UnLockController from 'Controller/UnLockController'


const UnlockDoor = (props) => {

    useEffect(() => {
        async function fetchMyAPI() {
            await props.setProps({
                rightSidebarFormData: []
            })
        }

        fetchMyAPI()
    }, [])

    return (
        // <>sas</>
        <UnLockController
            pagename={props.pagename}
        />
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    setProps: (payload) => dispatch(setProps(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(UnlockDoor)